export default function(
    $uibModalInstance,
    areTicketsCollected,
    isAmendmentSentForApproval,
    tripId,
) {
    'ngInject';

    const vm = this;
    Object.assign(vm, {
        areTicketsCollected,
        isAmendmentSentForApproval,
        tripId,
        dismiss,
        close,
    });

    function dismiss() {
        $uibModalInstance.dismiss('cancel');
    }

    function close() {
        $uibModalInstance.close('close');
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/rail-amendment/rail-rebook-success-modal-controller.js